import React, { useEffect, useState } from "react";
import ImageCrop from "../ImageCropModal/ImageCrop";
import VideoCrop from "../VideoCropModal/VideoCrop";
import {
    NOTICE_IMAGE_ASPECT_RATIOS,
    NOTICE_VIDEO_ASPECT_RATIOS
} from "src/scenes/Noticeboard/constants";

export default function CarouselCropModal({
    isOpen,
    onClose,
    carouselAssets,
    setCarouselAssets,
    carouselCurrentAsset,
    setCarouselCurrentAsset,
    noticeMedia,
    onImageCropComplete,
    onVideoCropComplete,
    lockedAspectRatio
}) {
    const [croppedAssets, setCroppedAssets] = useState([]);
    const hasVideoAsset = carouselAssets.some(asset => asset.type === "video");
    const imageAspectRatios = hasVideoAsset ? NOTICE_VIDEO_ASPECT_RATIOS : NOTICE_IMAGE_ASPECT_RATIOS;

    const onImageComplete = async (croppedImage, width, height, aspectRatio) => {
        setCroppedAssets(prev => {
            return [...prev, { index: carouselCurrentAsset.index, croppedImage }];
        });
        await onImageCropComplete(croppedImage, width, height, aspectRatio);
    };

    const onVideoComplete = async (file, crop, trimStart, trimEnd, aspectRatio) => {
        setCroppedAssets(prev => {
            return [...prev, { index: carouselCurrentAsset.index, file }];
        });
        await onVideoCropComplete(file, crop, trimStart, trimEnd, aspectRatio);
    };

    useEffect(() => {
        if (carouselAssets.length !== croppedAssets.length) {
            setCarouselCurrentAsset(carouselAssets[croppedAssets.length]);
        }
    }, [croppedAssets]);

    useEffect(() => {
        if (carouselAssets && croppedAssets.length === carouselAssets.length) {
            onClose();
        }
    }, [noticeMedia, carouselAssets]);

    return (
        <>
            <ImageCrop
                imageSrc={carouselCurrentAsset.data}
                isOpen={carouselAssets && carouselCurrentAsset && carouselCurrentAsset.type === "image"}
                onCropComplete={onImageComplete}
                aspectRatios={imageAspectRatios}
                allowedOrientations={["landscape", "portrait"]}
                carouselAssets={carouselAssets}
                setCarouselAssets={setCarouselAssets}
                carouselCurrentAsset={carouselCurrentAsset}
                setCarouselCurrentAsset={setCarouselCurrentAsset}
                onClose={onClose}
                croppedAssets={croppedAssets}
                lockedAspectRatio={lockedAspectRatio}
                returnAspectRationResult={true}
            />
            <VideoCrop
                videoSrc={carouselCurrentAsset.data}
                isOpen={carouselAssets && carouselCurrentAsset && carouselCurrentAsset.type === "video"}
                onClose={onClose}
                onCropComplete={onVideoComplete}
                aspectRatios={NOTICE_VIDEO_ASPECT_RATIOS}
                allowedOrientations={["landscape"]}
                carouselAssets={carouselAssets}
                setCarouselAssets={setCarouselAssets}
                carouselCurrentAsset={carouselCurrentAsset}
                setCarouselCurrentAsset={setCarouselCurrentAsset}
                croppedAssets={croppedAssets}
                lockedAspectRatio={lockedAspectRatio}
            />
        </>
    );
}
